import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { UserDetails } from "domain/user";
import { StoreState } from "store";
import { TenantDetails } from "store/tenantDetails";

// Run the callback once per session as soon as the user and the user's own tenant details are known.
export const useOncePerLogin = (callback: (user: UserDetails, tenantDetails: TenantDetails) => void) => {
    const user = useSelector((state: StoreState) => state.userReducer.user);
    const tenantDetails = useSelector((state: StoreState) => state.tenantDetailsReducer.stack[0]);
    const userRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        if (!user) {
            userRef.current = undefined;
            return;
        }

        if (!tenantDetails || userRef.current === user.uuid) {
            return;
        }

        userRef.current = user.uuid;
        callback(user, tenantDetails);
    }, [user?.uuid, tenantDetails?.uuid]);
};
